module.exports = __webpack_public_path__ + "static/media/jian.e641a110.jpg";